<div class="card mb-0 main-card overflow-auto">
  <div class="card-header">
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="card-title align-items-center d-flex p-0">
        Flag Analysis
        <span class="badge text-dark bg-body-secondary ms-2">{{ TotaReports }}</span>
      </h5>
      <div class="d-flex">
        <div class="search-bar">
          <div class="form-group">
            <div class="input-group">
              <select class="form-select form-control" id="clinicId" aria-label="Clinic" (change)="filterAppointmentType($event)" [(ngModel)]="SelectedAppt">
                <ng-container *ngFor="let appt of AppointmentTypes">
                  <option [value]="appt.key">{{ appt.value }}</option>
                </ng-container>
              </select>
            </div>
          </div>
        </div>
        <date-range-picker [maxDate]="MaxDate" [fromDate]="fromDate" [toDate]="toDate" (toDateChange)="toDateChange($event)" (fromDateChange)="fromDateChange($event)"> </date-range-picker>
        <button type="button" class="btn btn-outline-primary export-button" (click)="exportReport()">Export<i class="bi bi-box-arrow-right fs-5 mx-1"></i></button>
      </div>
    </div>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive h-100">
      <table class="table table-hover table-x-padding mb-0" *ngIf="TotaReports || IsLoading">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th *ngIf="currentClinic < 1" scope="col">Clinic Name</th>
            <!-- MD Columns -->
            <th *ngIf="showAll || showMD" scope="col">Next MD Appt</th>
            <th *ngIf="showAll || showMD" scope="col">Next ROM Appt</th>
            <!-- MRI Columns -->
            <th *ngIf="showAll || showMRI" scope="col">C Schedule</th>
            <th *ngIf="showAll || showMRI" scope="col">L Schedule</th>
            <th *ngIf="showAll || showMRI" scope="col">T Schedule</th>
            <th *ngIf="showAll || showMRI" scope="col">Omri Schedule1</th>
            <th *ngIf="showAll || showMRI" scope="col">Omri Schedule2</th>
            <th *ngIf="showAll || showMRI" scope="col">Omri Schedule3</th>
            <th *ngIf="showAll || showMRI" scope="col">Omri Schedule4</th>
            <!-- Neuro Columns -->
            <th *ngIf="showAll || showNeuro" scope="col">Next Neurologist</th>
            <th *ngIf="showAll || showNeuro" scope="col">Uemg</th>
            <th *ngIf="showAll || showNeuro" scope="col">Lemg</th>
            <!-- Ortho Columns -->
            <th *ngIf="showAll || showOrtho" scope="col">Next Ortho Appt</th>
            <th *ngIf="showAll || showOrtho" scope="col">Surgery 1</th>
            <th *ngIf="showAll || showOrtho" scope="col">Surgery 2</th>
            <!-- Pain Columns -->
            <th *ngIf="showAll || showPain" scope="col">Next Pain Appt</th>
            <th *ngIf="showAll || showPain" scope="col">Pain Surgery 1</th>
            <th *ngIf="showAll || showPain" scope="col">Pain Surgery 2</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngIf="!IsLoading">
            <tr *ngFor="let item of reportList; index as i">
              <th scope="row">{{ i + 1 }}</th>
              <td>{{ item.firstName }} {{ item.lastName }}</td>
              <td *ngIf="currentClinic < 1">{{ item.clinicName }}</td>
              <!-- MD Columns -->
              <td *ngIf="showAll || showMD" [ngClass]="{ 'text-danger': item.nextMDAppt }">
                {{ item.nextMDAppt ? (item.nextMDAppt | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showMD" [ngClass]="{ 'text-danger': item.nextROMAppt }">
                {{ item.nextROMAppt ? (item.nextROMAppt | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <!-- MRI Columns -->
              <td *ngIf="showAll || showMRI" [ngClass]="{ 'text-danger': item.cSchedDate }">
                {{ item.cSchedDate ? (item.cSchedDate | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showMRI" [ngClass]="{ 'text-danger': item.lSchedDate }">
                {{ item.lSchedDate ? (item.lSchedDate | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showMRI" [ngClass]="{ 'text-danger': item.tSchedDate }">
                {{ item.tSchedDate ? (item.tSchedDate | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showMRI" [ngClass]="{ 'text-danger': item.omriSchedDate1 }">
                {{ item.omriSchedDate1 ? (item.omriSchedDate1 | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showMRI" [ngClass]="{ 'text-danger': item.omriSchedDate2 }">
                {{ item.omriSchedDate2 ? (item.omriSchedDate2 | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showMRI" [ngClass]="{ 'text-danger': item.omriSchedDate3 }">
                {{ item.omriSchedDate3 ? (item.omriSchedDate3 | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showMRI" [ngClass]="{ 'text-danger': item.omriSchedDate4 }">
                {{ item.omriSchedDate4 ? (item.omriSchedDate4 | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <!-- Neuro Columns -->
              <td *ngIf="showAll || showNeuro" [ngClass]="{ 'text-danger': item.nextNeuro }">
                {{ item.nextNeuro ? (item.nextNeuro | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showNeuro" [ngClass]="{ 'text-danger': item.uemgDate }">
                {{ item.uemgDate ? (item.uemgDate | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showNeuro" [ngClass]="{ 'text-danger': item.lemgDate }">
                {{ item.lemgDate ? (item.lemgDate | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <!-- Ortho Columns -->
              <td *ngIf="showAll || showOrtho" [ngClass]="{ 'text-danger': item.nextOrthoAppt }">
                {{ item.nextOrthoAppt ? (item.nextOrthoAppt | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showOrtho" [ngClass]="{ 'text-danger': item.surgeryDate1 }">
                {{ item.surgeryDate1 ? (item.surgeryDate1 | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showOrtho" [ngClass]="{ 'text-danger': item.surgeryDate2 }">
                {{ item.surgeryDate2 ? (item.surgeryDate2 | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <!-- Pain Columns -->
              <td *ngIf="showAll || showPain" [ngClass]="{ 'text-danger': item.paNextPainAppt }">
                {{ item.paNextPainAppt ? (item.paNextPainAppt | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showPain" [ngClass]="{ 'text-danger': item.paSurgeryDate1 }">
                {{ item.paSurgeryDate1 ? (item.paSurgeryDate1 | date : 'MM/dd/yyyy') : '-' }}
              </td>
              <td *ngIf="showAll || showPain" [ngClass]="{ 'text-danger': item.paSurgeryDate2 }">
                {{ item.paSurgeryDate2 ? (item.paSurgeryDate2 | date : 'MM/dd/yyyy') : '-' }}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <div class="empty-data-placeholder" *ngIf="TotaReports == 0 && !IsLoading">
        <div class="text-center">
          <h3 class="text-body-tertiary"><i class="bi bi-exclamation-triangle"></i> Oops..!</h3>
          <p>No Reports Found</p>
        </div>
      </div>
    </div>
  </div>
</div>
